import Vue from 'vue';
import Vuex from 'vuex';

import {
    PRIVACY_MODULE_STORE_NAME,
    INFORMATION_STORAGE_ACCESS_KEY,
    PERSONALIZATION_ITEM_KEY,
    AD_SELECTION_KEY,
    CONTENT_SELECTION_KEY,
    MEASUREMENT_KEY,
    AD_SELECTION_MUTATION_KEY,
    CONTENT_SELECTION_MUTATION_KEY,
    INFORMATION_STORAGE_ACCESS_MUTATION_KEY,
    MEASUREMENT_MUTATION_KEY,
    PERSONALIZATION_ITEM_MUTATION_KEY,
} from '../constants';

Vue.use(Vuex);

let privacyConsentSettings;
try {
    privacyConsentSettings = JSON.parse(localStorage.getItem(PRIVACY_MODULE_STORE_NAME));
    if (privacyConsentSettings === null) {
        privacyConsentSettings = {};
    }
} catch {
    privacyConsentSettings = {};
}

export default {
    namespaced: true,
    state: {
        informationStorageAndAccess: privacyConsentSettings[INFORMATION_STORAGE_ACCESS_KEY],
        personalisation: privacyConsentSettings[PERSONALIZATION_ITEM_KEY],
        adSelection: privacyConsentSettings[AD_SELECTION_KEY],
        contentSelection: privacyConsentSettings[CONTENT_SELECTION_KEY],
        measurement: privacyConsentSettings[MEASUREMENT_KEY],
        themeColor: 'primary',
    },
    mutations: {
        setPrivacyConsentComponent(state, value) {
            state.privacyConsentComponent = value;
        },
        setRegisteredItems(state, value) {
            state.registeredItems = value;
        },
        setThemeColor: (state, value) => state.themeColor = value,
        [INFORMATION_STORAGE_ACCESS_MUTATION_KEY](state, value) {
            state.informationStorageAndAccess = value;
        },
        [PERSONALIZATION_ITEM_MUTATION_KEY](state, value) {
            state.personalisation = value;
        },
        [AD_SELECTION_MUTATION_KEY](state, value) {
            state.adSelection = value;
        },
        [CONTENT_SELECTION_MUTATION_KEY](state, value) {
            state.contentSelection = value;
        },
        [MEASUREMENT_MUTATION_KEY](state, value) {
            state.measurement = value;
        },
    },
};